import { render } from "./ManageLabelsEdit.vue?vue&type=template&id=34f57c72&scoped=true"
import script from "./ManageLabelsEdit.vue?vue&type=script&lang=js"
export * from "./ManageLabelsEdit.vue?vue&type=script&lang=js"

import "./ManageLabelsEdit.vue?vue&type=style&index=0&id=34f57c72&scoped=true&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f57c72"]])

export default __exports__